import get from 'lodash/get';
import { FETCH_RAW_CRC_PM_LIST, FETCH_RAW_CRC_PM_LIST_SUCCESS, FETCH_RAW_CRC_PM_LIST_FAILURE, FETCH_RAW_CM_CRC_LIST, FETCH_RAW_CM_CRC_LIST_SUCCESS, FETCH_RAW_CM_CRC_LIST_FAILURE, FETCH_RAW_PROJECT_SUMMERY_LIST, FETCH_RAW_PROJECT_SUMMERY_LIST_SUCCESS, FETCH_RAW_PROJECT_SUMMERY_LIST_FAILURE, FETCH_RAW_ZPALGLOBAL_LIST, FETCH_RAW_ZPALGLOBALLIST_SUCCESS, FETCH_RAW_ZPALGLOBAL_FAILURE } from './types';

const initialState = {
    isRawCrcPmListLoading: false,
    isRawCmCrcListLoading: false,
    isRawProjectSummeryListLoading: false,
    rawCrcPmList: [],
    rawCmCrcList: [],
    rawProjectSummeryList: [],
    rawZpalglobalList:[],
    isZpalGlobalListLoading: false,

};

const projectMarginReducer = (state = initialState, action) => {
    switch (action.type) {
        //Raw crc pm 
        case FETCH_RAW_CRC_PM_LIST: {
            return {
                ...state,
                isRawCrcPmListLoading: true
            }
        }

        case FETCH_RAW_CRC_PM_LIST_SUCCESS: {
            const resData = get(action, 'response', []);
            return {
                ...state,
                rawCrcPmList: resData,
                isRawCrcPmListLoading: false
            }
        }

        case FETCH_RAW_CRC_PM_LIST_FAILURE: {
            return {
                ...state,
                isRawCrcPmListLoading: false
            }
        }

        //Raw  cm crc
        case FETCH_RAW_CM_CRC_LIST: {
            return {
                ...state,
                isRawCmCrcListLoading: true
            }
        }

        case FETCH_RAW_CM_CRC_LIST_SUCCESS: {
            const resData = get(action, 'response', []);
            return {
                ...state,
                rawCmCrcList: resData,
                isRawCmCrcListLoading: false
            }
        }

        case FETCH_RAW_CM_CRC_LIST_FAILURE: {
            return {
                ...state,
                isRawCmCrcListLoading: false
            }
        }

        //Raw  project summery list
        case FETCH_RAW_PROJECT_SUMMERY_LIST: {
            return {
                ...state,
                isRawProjectSummeryListLoading: true
            }
        }

        case FETCH_RAW_PROJECT_SUMMERY_LIST_SUCCESS: {
            const resData = get(action, 'response', []);
            return {
                ...state,
                rawProjectSummeryList: resData,
                isRawProjectSummeryListLoading: false
            }
        }

        case FETCH_RAW_PROJECT_SUMMERY_LIST_FAILURE: {
            return {
                ...state,
                isRawProjectSummeryListLoading: false
            }
        }


          //Raw  cm crc
          case FETCH_RAW_ZPALGLOBAL_LIST: {
            return {
                ...state,
                isZpalGlobalListLoading: true
            }
        }

        case FETCH_RAW_ZPALGLOBALLIST_SUCCESS: {
            const resData = get(action, 'response', []);
            return {
                ...state,
                rawZpalglobalList: resData,
                isZpalGlobalListLoading: false
            }
        }

        case FETCH_RAW_ZPALGLOBAL_FAILURE: {
            return {
                ...state,
                isZpalGlobalListLoading: false
            }
        }

        //

        default: {
            return state;
        }
    }
}

export default projectMarginReducer;